<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Vare" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view :options="product_groups" label="Varegruppe" v-model="entity.product_group_id" optionValueName="id" optionLabelName="label" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Label" v-model="entity.alt_label" />
					<string-view label="Beskrivelse" v-model="entity.label" />
					<string-view label="Varenummer" v-model="entity.sku" />
					<string-view label="Alt varenummer" v-model="entity.alt_sku" />
					<string-view label="Pris" v-model="entity.price" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Enhed" :options="_units" v-model="entity.unit" />
					<string-view label="Mandetimer pr. enhed" v-model="entity.man_hours" />
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Opret" @click="create" />
		</div>
		<div v-if="form && id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';

	export default {
		data() {
			return {
				entity: {
					label: null,
					price: null,
					sku: null,
					alt_sku: null,
					unit: null,
					alt_label: null,
					man_hours: 0
				},
				active: 'details',
				product_groups: [],
				units: []
			};
		},
		components: {
			'TextView': TextView,
			'StringView': StringView
		},
		computed: {
			_units() {
				return this.units.map(function (obj) {
					return {
						label: obj.label,
						value: obj.name
					};
				});
			},
			tabs: function () {
				if (this.id) {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
						/*{
							name: 'contacts',
							label: 'Contacts'
						}*/
					];
				} else {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
					];
				}
			}
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			invoiceSelect(name, id, label) {
				
				
				

				this.input(name, id);
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			create() {
				var win = this;

				
				

				this.axios
					.post('/products/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});		
			},
			update() {
				
				

				var win = this;

				this.axios
					.put('/products/' + this.id + '/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		mounted: function() {
			
			

			var self = this;

			if (this.id) {
				this.axios
					.get('/products/' + this.id + '/')
					.then(function (r) {
						self.entity = r.data;
						self.entity.roles = {...self._roles, ...self.entity.roles};
					});
			}

			this.axios
				.get('/product-groups/')
				.then(function (r) {
					self.product_groups = r.data._items;
				});

			this.axios
				.get('/products/units/')
				.then(function (r) {
					self.units = r.data._items;
				});
		}
	}
</script>

<style lang="scss">
	
</style>
